import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  productListDetails: {
    devices: [],
  },
  selectedProductDetails: {},
  lists: {
    categories: [],
    brands: [],
    products: [],
  },
  fields: {
    category: {},
    brand: {},
    product: {},
    newProduct: {},
  },
  purchasedPlans: [],
  showClaimEligibilityModal: false,
  claimEligibilityDetailsInDevices: [],
  planDetails: {},
}

const productSlice = createSlice({
  name: 'productSlice',
  initialState,
  reducers: {
    setProductListDetails: (state, action) => {
      let devices = [...state.productListDetails.devices, ...action.payload.devices]
      if (action.payload.currentPage === 1) {
        devices = [...action.payload.devices]
      }
      state.productListDetails = { ...action.payload, devices }
    },
    setSelectedProductDetails: (state, action) => {
      state.selectedProductDetails = action.payload
    },
    setEditProductDetails: (state, action) => {
      state.editProductDetails = action.payload
    },
    setLists: (state, action) => {
      state.lists = { ...state.lists, ...action.payload }
    },
    setFields: (state, action) => {
      state.fields = { ...state.fields, ...action.payload }
    },
    setPurchasedPlans: (state, action) => {
      state.purchasedPlans = [...action.payload]
    },
    setShowClaimEligibilityModal: (state, action) => {
      state.showClaimEligibilityModal = action.payload
    },
    setClaimEligibilityDetailsInDevice: (state, action) => {
      state.claimEligibilityDetailsInDevices = action.payload
    },
    setPlanDetails: (state, action) => {
      state.planDetails = action.payload
    },
  },
})

export default productSlice.reducer

export const {
  setProductListDetails,
  setSelectedProductDetails,
  setEditProductDetails,
  setLists,
  setFields,
  setPurchasedPlans,
  setShowClaimEligibilityModal,
  setClaimEligibilityDetailsInDevice,
  setPlanDetails,
} = productSlice.actions
